export default __webpack_public_path__ + "static/media/0xc6480da81151b2277761024599e8db2ad4c388c8.259a0581.webp";